import {library} from "@fortawesome/fontawesome-svg-core";
import {
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faChartPie,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faCubes,
    faEnvelope,
    faHeart,
    faInfoCircle,
    faNewspaper,
    faPlay,
    faQuestionCircle,
    faShoppingCart,
    faSignOutAlt,
    faSlidersH,
    faTimesCircle,
    faUser,
    faUsers,
    faQrcode,
    faKey,
    faScroll,
    faStar,
} from "@fortawesome/free-solid-svg-icons";

import {
  faStar as farStar
} from "@fortawesome/free-regular-svg-icons";

import {
    faFacebook,
} from "@fortawesome/free-brands-svg-icons";

library.add(
    faAngleLeft,
    faAngleRight,
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faAngleDown,
    faChartPie,
    faChevronLeft,
    faChevronRight,
    faChevronDown,
    faCheck,
    faCubes,
    faEnvelope,
    faFacebook,
    faHeart,
    faInfoCircle,
    faNewspaper,
    faPlay,
    faQuestionCircle,
    faShoppingCart,
    faSignOutAlt,
    faSlidersH,
    faTimesCircle,
    faUser,
    faUsers,
    faQrcode,
    faKey,
    faScroll,
    faStar,
    farStar
);



// WEBPACK FOOTER //
// ./src/AppIcons.js